import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Spinner, Table } from "reactstrap";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Container from "../../../components/Container";
import AppLayout from "../../../components/layouts/AppLayout";
import API from "../../../utils/API";
import Create from "./Create";
import Delete from "./Delete";
import Edit from "./Edit";

const Index = () => {
  const [rooms, setRooms] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchRooms = async () => {
    try {
      const data = (await API.get("/api/rooms")).data.data;
      setRooms(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRooms();
  }, [refresh]);

  return (
    <AppLayout>
      <Breadcrumbs
        title="Rooms"
        links={[
          {
            title: "Dashboard",
            link: null,
          },
          {
            title: "Rooms",
            link: null,
          },
        ]}
      />
      <Container>
        <Card className="border-0 shadow mt-5" style={{ minHeight: "70vh" }}>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h1 className="mb-0">All Rooms</h1>
              <Create room={rooms} fetchRooms={fetchRooms} />
            </div>
            <Table hover responsive>
              <thead>
                <tr className="bg-shade-blue">
                  <th>#</th>
                  <th>Name</th>
                  <th>Campus</th>
                  <th>block</th>
                  <th>Air Conditioned</th>
                  <th>Computer</th>
                  <th>Projector</th>
                  <th>Active</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {rooms.length > 0 ? (
                  rooms.map((room, index) => (
                    <tr
                      key={`room-${room.id}`}
                      style={{ verticalAlign: "middle" }}>
                      <th scope="row">{index + 1}</th>
                      <td>{room.name}</td>
                      <td>{room.relationships.campus.name}</td>
                      <td>{room.relationships.block.name}</td>
                      {room.is_air_conditioned == 1 ? (
                        <td>Yes</td>
                      ) : (
                        <td>No</td>
                      )}
                      {room.has_computer == 1 ? <td>Yes</td> : <td>No</td>}
                      {room.has_projector == 1 ? <td>Yes</td> : <td>No</td>}
                      {room.is_active == 1 ? <td>Yes</td> : <td>No</td>}
                      <td>
                        <Edit room={room} fetchrooms={fetchRooms} />
                        <Delete
                          room={room}
                          refresh={refresh}
                          setRefresh={setRefresh}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      {loading ? (
                        <Spinner style={{ width: "30px", height: "30px" }} />
                      ) : (
                        "No Rooms Exists"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </AppLayout>
  );
};

export default Index;
